if (!customElements.get('lig-lookbook')) {
  customElements.define('lig-lookbook', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-lb-filter]');
        if (filter) {
          this.querySelectorAll('[data-lb-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          this.querySelectorAll('[data-lb-kind]').forEach(look => look.hidden = filter.dataset.lbFilter !== 'all' && look.dataset.lbKind !== filter.dataset.lbFilter);
          return;
        }
        const variant = event.target.closest('[data-lb-variant]');
        if (!variant || variant.disabled) return;
        const card = variant.closest('.lig-lb__card');
        card.querySelectorAll('[data-lb-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
        card.querySelector('[data-lb-size]').textContent = variant.dataset.lbVariantSize;
        card.querySelector('[data-lb-price]').textContent = variant.dataset.lbVariantPrice;
        card.querySelector('[data-lb-shop]').href = variant.dataset.lbUrl;
      }, { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
